// translations/pages/landing/uk.js

export const landingPageUK = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "Локальні ШІ-рішення з акцентом на захист даних",
    "vision": "Наступний щабель продуктивності: Organisation as a Service. Співробітники-ШІ беруть на себе роботу від ідеї до перевіреного результату.",
    "intro": "Ми досліджуємо, розробляємо та інтегруємо технології штучного інтелекту, машинного навчання й обробки даних. Результатом є власні продукти та індивідуальні рішення, які локально аналізують, структурують, анонімізують і захищають дані — а разом із [Veridion](veridion) також повністю автоматизовані ШІ-співробітники, які спільно з людьми беруть на себе цілі напрями роботи компанії.",
    "detail": "Програмне забезпечення, яке ми встановлюємо в замовника, працює в його власній інфраструктурі й не потребує підключення до хмари. Документи, дані та мовні моделі залишаються всередині організації."
  },
  "partners": {
    "title": "Партнери, які нам довіряють",
    "subtitle": "Компанії та дослідницькі установи, у яких наша ШІ-організація працює в продуктивному режимі.",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\nРішення для айтрекінгу та аналізу біосигналів для ваших досліджень",
        "description": [
          "BiSigma спеціалізується на системах вимірювання й аналізу біосигналів, а також на високоточних рішеннях для айтрекінгу (відстеження руху очей) для науки, клінічної практики та промислових досліджень.",
          "Компанія pAIoneer Labs GmbH повністю замінила в BiSigma розробку програмного забезпечення штучним інтелектом, який успішно створює та постійно розвиває програмне забезпечення для вимірювання й аналізу біосигналів."
        ],
        "cta": "Відвідати BiSigma"
      }
    }
  },
  "products": {
    "title": "Продукти",
    "subtitle": "Ми продаємо програмне забезпечення як настільні застосунки для робочого місця, як серверне програмне забезпечення on-premises або в хмарі замовника та як підписку на нашій платформі, як-от [асистент для трейдингу](finance), якого наші співробітники-ШІ розробляють самі. Крім того, ми будуємо ШІ-системи відповідно до вимог замовника, консультуємо та проводимо навчання.",
    "partnerLabel": "Продукт партнера",
    "priceOnRequest": "Ціна за запитом",
    "request": "Надіслати запит",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveil виявляє та анонімізує персональні дані у файлах Word, Excel, OpenDocument, PDF і текстових файлах, перш ніж вони потраплять до інструментів ШІ, тестів, аналітики або до третіх осіб. Виявлення поєднує {presidio}, {spacy} і {flair} та працює німецькою, англійською, французькою, італійською й іспанською мовами.",
          "Настільна версія працює автономно на звичайних комп’ютерах із Windows, macOS або Linux, без GPU та без залежності від мережі; файли не залишають робочого місця. Версія з API працює в інфраструктурі замовника — on-premises або у власній хмарі замовника — і вбудовує анонімізацію в наявні системи та робочі процеси.",
          "Режим заміни підставляє замість персональних даних заповнювачі для документації, пов’язаної з дотриманням нормативних вимог, а режим фіктивних даних — правдоподібні підставні значення для тестових середовищ; структура документа зберігається. З AnonChat анонімізований документ потрапляє до ChatGPT, Claude, Gemini або внутрішньої мовної моделі лише після попереднього перегляду."
        ],
        "cta": "Переглянути Kyveil"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "Один творець, нескінченна кількість рішень.",
        "text": [
          "Корпоративний ШІ pAIoneer Labs GmbH: він керує всією компанією — як повноцінна організація зі співробітників-ШІ з бізнес-підрозділами від розробки програмного забезпечення через електроніку та квантові обчислення аж до продажів і адміністрування, які очолює власний координаційний рівень.",
          "Цей колектив самостійно доводить до кінця проєкти, бухгалтерію, корпоративні знання, дослідження, розробку й аналіз даних. Його комунікація оптимізована теорією ігор, а коли йому потрібна здатність, якої ще не існує, він будує для неї власну ШІ-систему.",
          "Працює він локально, у вашій власній хмарі або на нашій платформі. Там він сам розробляє [асистента для трейдингу](finance) і є ШІ в його чаті."
        ],
        "points": [
          "Інтегрується в кожний процес",
          "Навчається самостійно",
          "Сама створює здатності, яких бракує",
          "Планована у фіксованих циклах"
        ],
        "cta": "Переглянути Veridion"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddy — це модульна агентна система на основі ШІ для компаній, яка автоматизує адміністративні офісні завдання.",
          "П’ять ролей охоплюють робочі будні: асистент координує зустрічі, складає чернетки електронних листів і виконує щоденні завдання. Коуч супроводжує емоційні та соціальні аспекти професійного життя, допомагає в конфліктах і підтримує особистісний розвиток. Помічник із захисту даних відповідає на фахові запитання щодо захисту даних і приватності, а також його можна навчити інших спеціалізованих напрямів, як-от пожежна безпека чи комплаєнс. Тренер із навчання створює плани підвищення кваліфікації, програми адаптації нових працівників і навчальні модулі, а консультант аналізує завантажені документи, підтримує ухвалення рішень і дає стратегічні рекомендації.",
          "RoBuddy на 100 % розміщується та адмініструється відповідно до німецьких стандартів (GDPR, BSI-Grundschutz) і безперешкодно підключається до Nextcloud або будь-якого мережевого диска.",
          "RoBuddy — це агентна система для офісної роботи, яку можна поєднати з Veridion в один корпоративний ШІ, що охоплює всю компанію: RoBuddy бере на себе завдання на робочому місці, Veridion підключає системи та дані компанії."
        ],
        "cta": "Переглянути RoBuddy",
        "vendorNote": "RoBuddy — продукт Dr. Hornecker Software-Entwicklung und IT-Dienstleistungen. Збут здійснює pAIoneer Labs GmbH."
      }
    }
  },
  "platformNote": {
    "title": "SaaS-платформа",
    "description": "Цим застосунком ви користуєтеся за підпискою безпосередньо в браузері, без встановлення. Він працює на нашій власній платформі, для входу потрібен другий фактор, а всі звернення до ШІ проходять через єдину центральну точку доступу з фіксованими квотами.",
    "apps": {
      "finance": {
        "name": "ШІ-асистент для трейдингу",
        "text": "Ви підключаєте свій брокерський рахунок, звичайною мовою ставите запитання про свої позиції й бачите, які новини вплинули на курси. Для кожного фінансового інструмента окрема модель машинного навчання, яку щодня навчають заново, розраховує прогноз, а автоматика може торгувати за сигналами. Асистента розробляють наші співробітники-ШІ; у чаті вони є також його ШІ.",
        "cta": "Переглянути асистента для трейдингу"
      }
    }
  },
  "services": {
    "title": "Основні напрями послуг",
    "veridion": {
      "title": "Співробітники-ШІ",
      "description": "Цілі сфери роботи, укомплектовані співробітниками-ШІ, які інтегруються в процеси та інструменти компанії й самостійно доводять роботу до кінця. Так працюємо ми самі: pAIoneer Labs GmbH працює на цьому.",
      "cta": "Переглянути Veridion",
      "features": [
        "Organisation as a Service",
        "Бізнес-підрозділи зі співробітників-ШІ",
        "Комунікація, оптимізована теорією ігор",
        "Локально або у власній хмарі"
      ]
    },
    "custom": {
      "title": "ШІ-системи на замовлення",
      "description": "Ми розробляємо системи для аналізу, обробки, структурування, анонімізації та захисту даних відповідно до вимог замовника й інтегруємо їх у локальні ІТ-інфраструктури або ІТ-інфраструктури, що належать замовникові.",
      "features": [
        "Робота без хмари",
        "Розробка продуктів",
        "Прототипи",
        "Проєкти досліджень і розробок"
      ]
    },
    "elektronik": {
      "title": "Електроніка та вбудоване ПЗ",
      "description": "Близька до апаратного забезпечення розробка як послуга: проєктування схем і симуляція як цифровий двійник, вбудоване ПЗ аж до сенсора, оцінювання компонентів і альтернатив, перш ніж щось буде виготовлено.",
      "features": [
        "Цифрові двійники",
        "Вбудоване ПЗ",
        "Аналіз технічних описів",
        "Оцінювання компонентів"
      ]
    },
    "quantum": {
          "title": "Суверенні LLM та Квантовий ШІ",
          "description": "Наша мета під керуванням Veridion: розробити компактні мовні моделі Made in Germany, які конкуруватимуть із великими моделями США та Китаю, та власні квантові трансформери.",
          "cta": "Переглянути Quantum",
          "features": [
                "Мовні моделі Made in Germany",
                "Квантові трансформери",
                "Власна Quantum IDE",
                "ШІ розвиває ШІ"
          ]
    },
    "dataanalysis": {
      "title": "Аналіз даних у розмові",
      "description": "ШІ-співробітник відповідає на запитання до підключених джерел даних. Він читає каталоги, схеми та стовпці баз даних, перед доступом до даних подає план аналізу та з’ясовує неоднозначності.",
      "features": [
        "Джерела даних SQL",
        "Кореляція та регресія",
        "Таблиці та діаграми",
        "Експорт у PDF і PowerPoint"
      ]
    },
    "memory": {
      "title": "Корпоративна пам’ять",
      "description": "Пам’ять замість пошуку документів: факти, рішення, завдання та процеси, пов’язані з проєктами, людьми, системами й документами, до яких вони належать, разом із часом, у якому вони чинні. Вона росте сама собою з розмов, зустрічей і результатів роботи; новіше рішення заступає старіше щодо тієї самої теми, ніщо не втрачається.",
      "features": [
        "Граф знань",
        "Факти з прив’язкою до часу",
        "Рішення, які не губляться",
        "Доступ за відповідальністю"
      ]
    },
    "kyveil": {
      "title": "Локальна анонімізація без GPU",
      "description": "Kyveil анонімізує персональні дані локально — як настільний застосунок на звичайних комп’ютерах із Windows, macOS або Linux або як REST API в інфраструктурі замовника, без обов’язкової хмари та без GPU.",
      "cta": "Переглянути Kyveil",
      "features": [
        "Анонімізація перед ШІ",
        "Виявлення PII за допомогою NLP",
        "Windows, macOS, Linux",
        "REST API on-premises"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "Розробка програмного забезпечення з підтримкою ШІ потребує надійного контексту. IDD фіксує цілі, нецілі, сценарії, правила для агентів і рішення як придатну до використання пам’ять проєкту.",
      "cta": "Переглянути IDD",
      "features": [
        "Агентна розробка",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "Сценарії як тести"
      ]
    },
    "finance": {
      "title": "Фінанси та аналіз ринку",
      "description": "За асистентом для трейдингу стоїть власний бізнес-підрозділ із цифрових співробітників: ШІ-дата-сайєнтисти та фінансові експерти. Вони оцінюють новини в реальному часі, аналізують емоції фінансових новин і самі виконують розрахунки на ринкових даних у чаті: кореляції, регресії, діаграми та підсумок власних прогнозів, кожне число — з виконаного кроку розрахунку. Під ними працюють прогноз машинного навчання для кожного фінансового інструмента й автоматична торгівля на демонстраційному та реальному рахунку.",
      "cta": "Переглянути фінанси",
      "features": [
        "ШІ-дата-сайєнтисти та фінансові експерти",
        "Новини в реальному часі, з аналізом емоцій",
        "ML-прогноз для кожного фінансового інструмента",
        "Автоматична торгівля"
      ]
    },
    "consulting": {
      "title": "Консультування",
      "description": "Ми консультуємо з технічних, організаційних і стратегічних питань впровадження ШІ, його убезпечення та використання відповідно до нормативних вимог.",
      "features": [
        "Врядування у сфері ШІ",
        "Управління даними",
        "Захист даних",
        "Інформаційна безпека"
      ]
    }
  },
  "contact": {
    "title": "Контакти",
    "addressLabel": "Адреса",
    "phoneLabel": "Телефон",
    "emailLabel": "Електронна пошта",
    "cta": "Написати повідомлення"
  }
};
